import { addMethod, string } from 'yup';

addMethod(string, 'rega', ({ message }) => string().test('test-rega', message, (value) => {
  const pattern = /^\s*([A-Z]{2})\s*([0-9]{2})\s*([0-9]{3})\s*([0-9]{7})\s*$/i;
  return pattern.test(value ?? '');
}));
